import { useState } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { openProviderCircuit, closeProviderCircuit, setProviderEnabled, setProviderPolicy } from '../api';
import { useToast } from '../../../common/hooks';

export const useProviderHealthActions = () => {
    const queryClient = useQueryClient();
    const { success: successToast, error: errorToast } = useToast();
    const [busyProvider, setBusyProvider] = useState(null);

    const invalidate = () => {
        queryClient.invalidateQueries({ queryKey: ['operations'] });
    };

    const open = useMutation({
        mutationFn: async (provider) => openProviderCircuit(provider),
        onSuccess: () => {
            successToast('مدار قطع شد');
            invalidate();
        },
        onError: (err) => {
            errorToast(err?.response?.data?.message || 'خطا در قطع مدار');
        },
    });

    const close = useMutation({
        mutationFn: async (provider) => closeProviderCircuit(provider),
        onSuccess: () => {
            successToast('مدار بسته شد');
            invalidate();
        },
        onError: (err) => {
            errorToast(err?.response?.data?.message || 'خطا در بستن مدار');
        },
    });

    const enable = useMutation({
        mutationFn: async ({ provider, enabled }) => setProviderEnabled(provider, enabled),
        onSuccess: () => {
            successToast('وضعیت سرویس به‌روزرسانی شد');
            invalidate();
        },
        onError: (err) => {
            errorToast(err?.response?.data?.message || 'خطا در به‌روزرسانی وضعیت');
        },
    });

    const policy = useMutation({
        mutationFn: async ({ provider, policy }) => setProviderPolicy(provider, policy),
        onSuccess: () => {
            successToast('خط‌مشخصات خط‌شکن به‌روزرسانی شد');
            invalidate();
        },
        onError: (err) => {
            errorToast(err?.response?.data?.message || 'خطا در به‌روزرسانی خط‌مشخصات');
        },
    });

    const runOpen = (provider) => {
        setBusyProvider(provider);
        open.mutateAsync(provider).finally(() => setBusyProvider(null));
    };

    const runClose = (provider) => {
        setBusyProvider(provider);
        close.mutateAsync(provider).finally(() => setBusyProvider(null));
    };

    const runEnable = (provider, enabled) => {
        setBusyProvider(provider);
        enable.mutateAsync({ provider, enabled }).finally(() => setBusyProvider(null));
    };

    return { open: runOpen, close: runClose, enable: runEnable, policy, busyProvider };
};

export default useProviderHealthActions;